import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { PrSidepanelService } from '@app/components/pr-sidepanel/pr-sidepanel.service';
import { EaSimulationAvPackFormComponent } from '@app/forms/simulation/ea-simulation-av-pack-form/ea-simulation-av-pack-form.component';

@Component({
    selector: 'app-template',
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.scss'],
    standalone: false
})
export class TemplateComponent implements OnInit {
  sortBy = 'default';

  tableData: any[] = [
    {
      name: 'Girardin 2020',
      type: 'Girardin',
      owner: 'Inter Invest',
      date: '10/01/2021',
      amount: '10 000€',
      defisc: '12 500€',
    },
    {
      name: 'Memorizer',
      type: 'FCPI',
      owner: 'Station F',
      date: '10/01/2021',
      amount: '12 000€',
      defisc: '3 500€',
    },
    {
      name: 'FCPI - HUGO',
      type: 'FIP',
      owner: 'ABN Armo',
      date: '10/01/2021',
      amount: '5 000€',
      defisc: '1 250€',
    },
  ];

  columnDefinitions = [
    ['name', 'Nom du produit'],
    ['type', 'Type'],
    ['owner', 'Gestionaire'],
    ['date', "Date d'achat"],
    ['amount', 'Montant investi'],
    ['defisc', 'Defiscalisation'],
  ];

  form: UntypedFormGroup;

  constructor(
    private sidePanelService: PrSidepanelService,
    private prFormService: PrFormService,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.form = formBuilder.group({
      date: [''],
      select: [''],
      radio: [''],
    });
  }

  ngOnInit() {}

  onChoiceSelected(event) {}

  onTableAction(ctx) {
    console.debug(ctx);
  }

  startForm(form) {
    this.prFormService.trigger(EaSimulationAvPackFormComponent, [], null, {});
  }
}
